import { render, staticRenderFns } from "./UserNavMenu.vue?vue&type=template&id=8a61ae32&scoped=true"
import script from "./UserNavMenu.vue?vue&type=script&lang=js"
export * from "./UserNavMenu.vue?vue&type=script&lang=js"
import style0 from "./UserNavMenu.vue?vue&type=style&index=0&id=8a61ae32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a61ae32",
  null
  
)

export default component.exports